import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@app/config/config.service';

@Injectable({
  providedIn: 'root'
})
export class XApiKeyService {
  constructor(private readonly appConfigService: AppConfigService) {}
  /**
   * Creates an HTTP header with the `x-api-key` for API requests.
   *
   * This method retrieves the API token from the application configuration service
   * and adds it to the HTTP headers. If the token is available, it returns a `HttpHeaders`
   * object with the `x-api-key` set. If the token is not available, it returns an empty `HttpHeaders` object.
   *
   * @returns A new `HttpHeaders` object containing the `x-api-key` header if the token is present, or an empty `HttpHeaders` object.
   */
  createApiHeader(): HttpHeaders {
    const apiKey: string | null = this.appConfigService.getData().oid.apiToken;
    if (apiKey) {
      return new HttpHeaders({
        'x-api-key': apiKey
      });
    }
    return new HttpHeaders();
  }
}
